// Serializes write requests through a single promise chain. Because every write
// rotates the session cookie, two writes firing in parallel could race (the 2nd
// uses the pre-rotation cookie -> 401). Chaining makes each wait for the
// previous cookie to settle. Shared by all forum client pages.
let writeChain: Promise<unknown> = Promise.resolve();

export function enqueueWrite<T>(fn: () => Promise<T>): Promise<T> {
  const run = writeChain.then(fn, fn);
  writeChain = run.then(
    () => undefined,
    () => undefined
  );
  return run;
}
